<template>
  <div>
    <success v-if="formSent" />
    <div v-else>
      <remind-form @formSent="formSent = true" />
      <div class="text-center">
        <router-link to="/">
          <a-button type="link" class="password-reset-link">
            <span class="underline">Wróć do logowania</span>
          </a-button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import RemindForm from './RemindForm'
import Success from './Success'

export default {
  components: {
    RemindForm,
    Success
  },
  data() {
    return {
      formSent: false
    }
  }
}
</script>

<style lang="scss" scoped>
.password-reset-link {
  margin-top: 14px;
  margin-bottom: -8px;
}
</style>
